// ─────────────────────────────────────────────────────────────────────────────
// DirectoryCard.js — the glass "User Directory" panel: toolbar + filter panel,
// the table, and the pagination footer. Analogue of Nodes' NetworkCard; it only
// composes the pieces and lays out the footer.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./DirectoryCard.module.css";
import UsersToolbar from "./UsersToolbar";
import UsersTable from "./UsersTable";

export default function DirectoryCard({
  search, onSearch,
  filterStatus, onFilterStatus,
  filterRole, onFilterRole,
  filterTeam, onFilterTeam,
  teams, hasFilters,
  users, loading, total,
  page, onPage, pageSize,
  onRowClick,
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className={styles.body}>
      <UsersToolbar
        search={search} onSearch={onSearch}
        filterStatus={filterStatus} onFilterStatus={onFilterStatus}
        filterRole={filterRole} onFilterRole={onFilterRole}
        filterTeam={filterTeam} onFilterTeam={onFilterTeam}
        teams={teams} hasFilters={hasFilters} total={total}
      />

      <UsersTable
        rows={users} loading={loading}
        onRowClick={onRowClick}
      />

      <div className={styles.footer}>
        <span className={styles.footerInfo}>
          {total > 0
            ? `Showing ${(page - 1) * pageSize + 1} to ${Math.min(page * pageSize, total)} of ${total} entries`
            : "No entries"}
        </span>
        <div className={styles.pagination}>
          <button className={styles.pageBtn} disabled={page === 1}
            onClick={() => onPage(page - 1)}>Previous</button>
          <button className={styles.pageBtn} disabled={page >= totalPages}
            onClick={() => onPage(page + 1)}>Next</button>
        </div>
      </div>
    </div>
  );
}
